import PostMessageEvent from "./PostMessageEvent";

const postWindowMessage = (type, version, data) => {
    window.parent.postMessage(
        JSON.stringify(new PostMessageEvent("embeddable.calendar", type, version, data)),
        '*'
    );
}

export default postWindowMessage;